import { DecodeHtml } from "../../utils/decodeHtml"
import { PropTypes } from 'prop-types';


const Sop = ({sops}) => {
    // const sop = [

    //     "USERS ARE RESPONSIBLE FOR THEIR OWN SAFETY",
    //     "USERS ARE REQUIRED TO WEAR ‘SWIMMING CAP’",
    //     "USERS ARE PROHIBITED FROM BRINGING FOOD FROM OUTSIDE",
    //     "USERS ARE PROHIBITED FROM USING DIVING EQUIPMENT",
    //     "USERS ARE FORBIDDEN IN THE SWIMMING POOL DURING HEAVY RAIN",
    //     "NO SMOKING & VAPE",
    //     "USERS WHO HAVE SKIN DISEASES ARE STRICTLY FORBIDDEN FROM USING THE SWIMMING POOL",
    //     "THE MAXIMUM NUMBER OF USERS ALLOWED AT ONE TIME ONLY 25 PEOPLE",
    //     "USERS MUST ALWAYS FOLLOW SAFETY INSTRUCTIONS AT ALL TIMES.THE LIFEGUARD ON DUTY HAS THE RIGHT TO PROHIBIT ANYONE FROM USING THE SWIMMING POOL WHO IS FOUND NOT TO COMPLY WITH THE SWIMMING POOL RULES.",
    // ]
    return (
        <div className="w-full flex flex-col  gap-2 my-5">
            <h1 className="w-auto   text-slate-900 text-2xl font-bold  uppercase">SOP SWIMMING POOL</h1>
            {/* <ul className="flex flex-col items-start gap-2 list-disc ml-3">
                {
                    sop.map((bullet, index) => (
                        <li key={index} className="w-auto  text-justify text-sky-950  text-base font-normal leading-normal list-disc list-inside">{bullet}</li>
                    ))
                }
            </ul> */}
            {
                DecodeHtml({html:sops})
            }
        </div>
    )
}
Sop.propTypes = {
    sops:PropTypes.string
}
export default Sop